import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { diasRestantes } from "@/lib/trial";

const OCULTO_EN = ["/app/billing", "/app/settings"];

const ETIQUETA = {
    reverse_trial: "Prueba de Pro",
    referral: "Pro gratis por invitación",
};

// Franja discreta mientras dura la prueba de Pro: sin modales ni popups. Solo los
// tres ultimos dias cambia de tono, y nunca donde la persona ya gestiona su plan.
export default function TrialBanner() {
    const location = useLocation();
    const [trial, setTrial] = useState(null);

    useEffect(() => {
        api.get("/api/billing/current-plan")
            .then((r) => setTrial(ETIQUETA[r.data?.trial?.source] ? r.data.trial : null))
            .catch(() => setTrial(null));
    }, []);

    if (!trial || OCULTO_EN.some((p) => location.pathname.startsWith(p))) return null;
    const dias = diasRestantes(trial.expires_at);
    if (dias <= 0) return null;
    const final = dias <= 3;
    const cuando = dias === 1 ? "Último día" : `Quedan ${dias} días`;

    return (
        <div
            className={`px-4 md:px-10 py-2 text-xs flex items-center justify-center gap-3 flex-wrap border-b ${final ? "bg-wine/5 border-wine/20 text-wine" : "bg-petrol/5 border-petrol/20 text-petrol"}`}
            data-testid="trial-banner"
        >
            <span>
                <strong className="font-medium">{ETIQUETA[trial.source]} · {cuando}.</strong>{" "}
                <span className="text-soft_muted">Al terminar vuelves al plan gratuito sin perder nada y sin ningún cargo.</span>
            </span>
            <Link to="/app/referrals" className="underline underline-offset-2">
                Gana un mes más invitando
            </Link>
            <Link to="/app/billing" className="underline underline-offset-2 font-medium">
                {final ? "Mantener Pro" : "Ver planes"}
            </Link>
        </div>
    );
}
